module.exports = __webpack_public_path__ + "fonts/Lato-Black.33d5f0d9.woff2";